import { AppConfig } from "@/lib/config";

const legacyModulesConfig = {
    mountId: "module-parent",                     
    remoteUrl: `${AppConfig.MARKETING_LEGACY_APPLICATION_URL}/remoteEntry.js`,
    remoteName: "marketing_legacy",
    modulePath: "./marketingModule",               
    mountParentSelector: null,                    
    mountProps: {
      base: "/accounts",
    },
}

const ModulesConfig = {
  mountId: "module-parent",                     
  remoteUrl: `${AppConfig.MARKETING_NEW_APPLICATION_URL}/remoteEntry.js`,
  remoteName: "marketing",
  modulePath: "./marketingModule",               
  mountParentSelector: null,                    
  mountProps: {},
}

const marketingModules = {
    "marketingLegacy":
    {
      defaultLayoutPage:{
        ...legacyModulesConfig,
        component: "defaultPage",
      }
    },
    "marketing":
    {
      defaultLayoutPage:{
        ...ModulesConfig,
        component: "defaultPage",
      }
    }
};

export default marketingModules;